import { OnInit, Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TYPE_USER } from 'src/app/core/const/const';
import { DashboardService } from 'src/app/core/services/dashboard/dashboard.service';
import { UserService } from 'src/app/core/user/user.service';

@Component({
  selector: 'app-modal-rgpd',
  templateUrl: './modal-rgpd.component.html',
  styleUrls: ['./modal-rgpd.component.scss'],
})
export class ModalRgpdComponent implements OnInit {
  @ViewChild('contentRGPD') contentRGPD?: any;
  @Input() isCreate: boolean = false;
  invalidCondition: boolean = true;
  isPartner: boolean = false;
  isAmbassador: boolean = false;
  showInfoRGPD = false;
  userInfo: any = {
    name: '',
    lastname: '',
    profils: [],
    newsletter: false,
    condition: null,
    password: '',
    confirmPassword: '',
    rgpdoffre: true,
    rgpdpartenaire: false,
    rgpdemail: true,
    recherchedepartement: '',
    recherchetexte: '',
    questionList: [],
    iban: null,
    bic: null,
    statutJuridique: null,
    assujetiTva: false,
    sendMailModif: false,
    civility: null,
    societe: null,
    nomSociete: null,
    rcs: null,
  };
  public userParams: any = {
    club: null,
    type: null,
    status: 2,
    email: null,
    password: null,
    name: null,
    lastname: null,
    phone: null,
    profil: [],
    waitForContact: 0,
    newsletter: 0,
    rgpdoffre: 1,
    rgpdpartenaire: 0,
    rgpdemail: 0,
    recherchedepartement: null,
    recherchetexte: null,
    adresse: null,
    codePostal: null,
    ville: null,
    questionList: null,
    iban: null,
    bic: null,
    statutJuridique: null,
    assujetiTva: 0,
    sendMailModif: 0,
    civility: null,
    societe: 0,
    nomSociete: null,
    rcs: null,
  };
  constructor(
    private modalService: NgbModal,
    private router: Router,
    private _userService: UserService,
    private _dashboardService: DashboardService
  ) {}

  openVertically(content: any) {
    this.modalService.open(content, { size: 'xl' });
  }
  /**
   * updateValue
   *
   * @WhatItDoes: check if target is checked and change invalidCondition value
   * @param target {HTMLObject} checkbox
   */
  updateValue(target: any) {
    if (target.checked) {
      this.invalidCondition = false;
    } else {
      this.invalidCondition = true;
    }
  }

  ngOnInit(): void {
    this.userInfo = this._userService.getUser();
    if (this.userInfo.rgpdvalide === null) {
      setTimeout(() => {
        this.openVertically(this.contentRGPD);
        this.formBuilder()
      }, 200);
    }
  }

  showinfoRGPD(){
    this.showInfoRGPD = true;
  }

  formBuilder() {
    if (this.userInfo) {
      this.userInfo['condition'] = true;
      this.isPartner = this.userInfo['type'].id == TYPE_USER.PARTNER;
      this.isAmbassador = this.userInfo['type'].id == TYPE_USER.AMBASSADOR;
      let profiles = this.userInfo.profils;
      let profileLength = profiles.length;

      for (let i = 0; i < profileLength; i++) {
        profiles[i].isDisabled = false;
        if (this.isPartner) {
          profiles[i].isDisabled = true;
        }
      }
    }
    this.invalidCondition = this.userInfo ? false : true;
    this.userInfo['rgpdoffre'] = 1;
    this.userInfo['rgpdemail'] = this.isCreate ? 1 : this.userInfo['rgpdemail'];
    this.userInfo['newsletter'] = this.isCreate ? 0 : this.userInfo['newsletter'];
  }

  onUserCreate(params: any, isCreate: boolean, popup: boolean = false) {
    this.userParams.newsletter = params.newsletter ? 1 : 0;
    this.userParams.rgpdoffre = 1;
    //this.userParams.rgpdoffre = params.rgpdoffre ? 1 : 0;
    this.userParams.rgpdpartenaire = params.rgpdpartenaire ? 1 : 0;
    this.userParams.rgpdemail = params.rgpdemail ? 1 : 0;
    this.userParams.condition = params.condition ? 1 : 0;
    this.userInfo.rgpdvalide = params.condition;
    this._dashboardService.updateUser(this.userParams).subscribe((response) => {
      // console.log(response);
    });
  }
}
